/**
 * Infinite scroll for the collection product grid.
 * Replaces Dawn's default click-through pagination: when the sentinel
 * element near the end of the grid comes into view, the next page of
 * products is fetched (via Shopify's section-rendering endpoint) and its
 * product cards are appended to the current grid.
 */
(function () {
  var observer = null;

  function stripAnimationState(item) {
    // Newly appended cards would otherwise stay invisible: Dawn's
    // scroll-reveal animation is initialized once on page load and doesn't
    // know about cards added later, so we just skip the animation for them.
    item.classList.remove('scroll-trigger', 'animate--slide-in');
    item.removeAttribute('data-cascade');
    item.style.removeProperty('--animation-order');
  }

  function loadNextPage(sentinel) {
    if (sentinel.dataset.loading === 'true') return;

    var nextUrl = sentinel.dataset.nextUrl;
    var sectionId = sentinel.dataset.sectionId;
    if (!nextUrl || !sectionId) return;

    sentinel.dataset.loading = 'true';
    if (observer) observer.unobserve(sentinel);

    var status = sentinel.nextElementSibling;
    var isStatus = status && status.classList && status.classList.contains('infinite-scroll-status');
    if (isStatus) status.hidden = false;

    var separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = nextUrl + separator + 'section_id=' + sectionId;

    fetch(fetchUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var currentGrid = document.getElementById('product-grid');

        if (newGrid && currentGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (item) {
            stripAnimationState(item);
            currentGrid.appendChild(item);
          });
        }

        var newSentinel = doc.querySelector('.infinite-scroll-sentinel');

        if (newSentinel) {
          sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
          sentinel.dataset.loading = 'false';
          if (observer) observer.observe(sentinel);
        } else {
          sentinel.remove();
        }

        if (isStatus) status.hidden = true;
      })
      .catch(function () {
        sentinel.dataset.loading = 'false';
        if (isStatus) status.hidden = true;
      });
  }

  function handleIntersections(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        loadNextPage(entry.target);
      }
    });
  }

  function init() {
    var sentinels = document.querySelectorAll('.infinite-scroll-sentinel');
    if (!sentinels.length) return;

    if (!observer) {
      observer = new IntersectionObserver(handleIntersections, {
        rootMargin: '0px 0px 600px 0px',
      });
    }

    sentinels.forEach(function (sentinel) {
      if (sentinel.dataset.observed === 'true') return;
      sentinel.dataset.observed = 'true';
      observer.observe(sentinel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Filtering/sorting (facets.js) replaces #ProductGridContainer's entire
  // contents, including the sentinel — re-scan for a fresh one afterwards.
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    new MutationObserver(init).observe(gridContainer, { childList: true });
  }
})();
